import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { useFeatureFlag } from '@client/hooks/useFeatureFlag';
import { useEffect } from 'react';

export function useInMaintenance() {
    const navigate = useNavigate();
    const inMaintenanceMode = useFeatureFlag('in-maintenance-mode');

    useEffect(() => {
        if (inMaintenanceMode) {
            navigate({
                to: '/maintenance',
                search: {
                    ol: window.location.href,
                },
            });
        }
    }, [inMaintenanceMode]);
}
